// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2eok5","icp":"footer_icp__22O0c","ga":"footer_ga__1qKP2"};